export type ChainAction = 'insert' | 'delete'

export const CHAIN_ACTION_LABELS: Record<ChainAction, string> = {
  insert: 'Insert Chain',
  delete: 'Delete Chain',
}

export const CHAIN_ACTION_DESCRIPTIONS: Record<ChainAction, string> = {
  insert: 'Add a new chain configuration',
  delete: 'Remove an existing chain configuration',
}
